import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AbbToastComponent } from '@components/abb-toast/abb-toast.component';
import { TranslateService } from '@ngx-translate/core';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  combineLatest,
  first,
  map,
  of,
} from 'rxjs'; /*
import { NotificationsService } from './notifications.service'; */

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  /* inAppPushNotificationsEnabled = signal(false); */
  private queue$ = new BehaviorSubject<
    Array<{
      type: 'success' | 'error' | 'warning';
      message: string | Observable<string>;
      htmlMessage?: boolean;
    }>
  >([]);
  private open$ = new BehaviorSubject(false);
  private subscriptions: Subscription[] = [];
  private currentToastRef: any = null;
  constructor(
    private snackBar: MatSnackBar,
    readonly translateService: TranslateService
  ) // NOTE: if this notification service logic is still necessary, it shouldn't be part of toast service
  // because toast service needs to stay ui only, with no business logic and external dependencies to avoid
  // circular dependency problems
  /*  private notificationsService: NotificationsService */
  {
    /* this.inAppPushNotificationsEnabled.set(
      Object.values(notificationsService.inAppPushEnabled$.value).every(
        (v) => v === true
      )
    ); */
    this.subscriptions.push(
      combineLatest([this.open$, this.queue$]).subscribe(
        ([currentlyOpen, queue]) => {
          //TODO: per il momento le disabilito se almeno uno è disabilitato, da sistemare inserendo le casistiche per evento (da specificare in qualche modo qui nei toasts)
          /* if (this.inAppPushNotificationsEnabled()) { */
          if (!queue.length || currentlyOpen) {
            return;
          }
          this.open$.next(true);
          this.notify(queue[0].type, queue[0].message, queue[0].htmlMessage);
          this.queue$.next(queue.slice(1));
          /* } else {
            this.subscriptions.forEach((s) => s.unsubscribe());
          } */
        }
      )
    );
  }

  private notify(
    type: 'success' | 'error' | 'warning',
    message: string | Observable<string>,
    htmlMessage?: boolean
  ) {
    const panelClass = {
      success: [
        '[&>*]:!bg-abb-background',
        '[&>*]:border-2',
        '[&>*]:border-abb-success',
        '[&_div]:text-abb-success',
      ],
      warning: [
        '[&>*]:!bg-abb-background',
        '[&>*]:border-2',
        '[&>*]:border-abb-warning',
        '[&_div]:text-abb-warning',
      ],
      error: [
        '[&>*]:!bg-abb-background',
        '[&>*]:border-2',
        '[&>*]:border-abb-error',
        '[&_div]:text-abb-error',
      ],
    }[type];
    const ref = this.snackBar.openFromComponent(AbbToastComponent, {
      panelClass: [...panelClass, 'relative'],
      duration: 10000,
      data: {
        message: typeof message === 'string' ? of(message) : message,
        htmlMessage: htmlMessage,
        queueSize$: this.queue$.pipe(map((queue) => queue.length)),
      },
      verticalPosition: 'top',
    });
    this.currentToastRef = ref;
    ref
      .afterDismissed()
      .pipe(first())
      .subscribe(() => {
        this.open$.next(false);
        if (this.currentToastRef === ref) {
          this.currentToastRef = null;
        }
      });
  }
  notifySuccess(
    message: string | Observable<string>,
    opts: { addToQueue?: boolean; htmlMessage?: boolean } = {
      addToQueue: true,
      htmlMessage: false,
    }
  ) {
    if ((!this.queue$.value.length && !this.open$.value) || opts.addToQueue) {
      this.queue$.next([
        ...this.queue$.value,
        { message, type: 'success', htmlMessage: opts.htmlMessage },
      ]);
    }
  }
  notifyWarning(
    message: string | Observable<string>,
    opts: { addToQueue?: boolean; htmlMessage?: boolean } = {
      addToQueue: true,
      htmlMessage: false,
    }
  ) {
    if ((!this.queue$.value.length && !this.open$.value) || opts.addToQueue) {
      this.queue$.next([
        ...this.queue$.value,
        { message, type: 'warning', htmlMessage: opts.htmlMessage },
      ]);
    }
  }
  notifyError(
    message: string | Observable<string>,
    opts: { addToQueue?: boolean; htmlMessage?: boolean } = {
      addToQueue: true,
      htmlMessage: false,
    }
  ) {
    if ((!this.queue$.value.length && !this.open$.value) || opts.addToQueue) {
      this.queue$.next([
        ...this.queue$.value,
        { message, type: 'error', htmlMessage: opts.htmlMessage },
        // { message: t('error', 'connection_error', this.translateService), type: 'error', htmlMessage: opts.htmlMessage }
      ]);
    }
  }

  dismissCurrentToast() {
    if (this.currentToastRef) {
      this.currentToastRef.dismiss();
      this.currentToastRef = null;
    }
  }
}
